<div class="wrapper">

  <p [innerHTML]="formModel.htmlText"></p>
</div>